var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vdpr-datepicker__calendar-input-date"},[_c('input',{staticClass:"vdpr-datepicker__calendar-input-date-elem",class:_vm.inputClass,attrs:{"type":"text"},domProps:{"value":_vm.formattedValue},on:{"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }